class ProgressEvents {

    constructor() {
        this.incListeners = [];
        this.startListeners = [];
        this.stopListeners = [];

    }

    increment() {
        this.incListeners.forEach((cb) => cb());
    }

    start() {
        this.startListeners.forEach((cb) => cb());
    }

    stop() {
        this.stopListeners.forEach((cb) => cb());
    }

    onStart(cb) {
        this.startListeners.push(cb);
    }

    onIncrement(cb) {
        this.incListeners.push(cb);
    }

    onStop(cb) {
        this.stopListeners.push(cb);
    }
}


export default ProgressEvents;